{
  "FormEngineStaticDatasource": {
    "title": "Statische Daten",
    "description": "Fügen Sie manuell statische Daten ein, die in Ihrem Formular verwendet werden sollen"
  },
  "mask": {
    "FormEngineStaticDatasource": {
      "description": "Beschreibung",
      "sourceType": "Quelle Typ",
      "resultPath": "Ergebnispfad",
      "resultPathPlaceholder": "z.B. Einträge",
      "labelColumn": "Spalte beschriften",
      "labelColumnPlaceholder": "z.B. {{.Etikett}}",
      "valueColumn": "Wertspalte",
      "valueColumnPlaceholder": "z.B. {{.Wert}}",
      "source": "Quelle",
      "setup": "Aufstellen",
      "data": "Durchsuche"
    }
  }
}